import React, { useContext, useEffect, useState } from 'react'
import { Button } from '@mui/material'
import { useHistory } from 'react-router-dom'
import Layout from '@/product/components/templates/Layout'
import commonContext from '@/product/context/common/commonContext'
import './Dashboard.css'
import Loaders from '@/product/components/molecules/Loaders'
import AuthContext from '@/product/context/auth/authContext'
import { greetingBasedOnTime } from '@/product/common/components'

const Dashboard = () => {
    const hue = 0
    const history = useHistory()
    const [isLoading, setIsLoading] = useState(true)
    const handleRedirect = (path) => {
        history.push(`/${path}`)
        window.scrollTo(0, 0)
    }
    const authContext = useContext(AuthContext)
    const { user } = authContext
    const dashboardContext = useContext(commonContext)
    const {
        getMainDashboardData,
        mainDashboardData,
        getAllCountries,
        getAllStates,
    } = dashboardContext
    const [getdashboard, setDashboard] = useState({
        activeCount: 0,
        draftCount: 0,
        soldbuynowCount: 0,
        unsoldCount: 0,
        bidCount: 0,
        paidCount: 0,
        paidUserCount: 0,
        saleCount: 0,
        soldProductdCount: 0,
        unSoldProductdCount: 0,
        totalTransaction: 0,
    })
    const [timeOfDay, setTimeOfDay] = useState('Morning')
    const cardList = [
        {
            label: 'Active',
            count: getdashboard.activeCount,
            path: 'listing/open',
        },
        {
            label: 'Draft',
            count: getdashboard.draftCount,
            path: 'listing/draft',
        },
        {
            label: 'Sold',
            count: getdashboard.soldCount,
            path: 'listing/sold',
        },
        {
            label: 'Unsold',
            count: getdashboard.unsoldCount,
            path: 'listing/unsold',
        },
    ]

    const reportList = [
        {
            label: 'Bids Per Month',
            count: getdashboard.bidCount,
        },
        {
            label: 'Sales Per Month',
            count: getdashboard.saleCount,
        },
        {
            label: 'Paid Per Month',
            count: getdashboard.paidCount,
        },
        // {
        //     label: 'Paid User Per Month',
        //     count: getdashboard.paidUserCount,
        // },
        {
            label: 'Sold Per Month',
            count: getdashboard.soldProductdCount,
        },
        {
            label: 'Unsold Per Month',
            count: getdashboard.unSoldProductdCount,
        },
        {
            label: 'Total Transaction Per Month',
            count: getdashboard.totalTransaction,
            symbol: '$',
        },
    ]
    useEffect(() => {
        setIsLoading(true)
        const filterBody = {
            filterRange: true,
            search: 'within',
            within: 'month',
        }
        getMainDashboardData(filterBody)
        getAllCountries()
        getAllStates()
    }, [])

    useEffect(() => {
        const currentTime = new Date().getHours()

        if (currentTime >= 0 && currentTime < 12) {
            setTimeOfDay('Morning')
        } else if (currentTime >= 12 && currentTime < 18) {
            setTimeOfDay('Afternoon')
        } else {
            setTimeOfDay('Evening')
        }
    }, [])

    useEffect(() => {
        setIsLoading(false)
        if (Object.keys(mainDashboardData).length > 0) {
            console.log('sathis', mainDashboardData)
            setDashboard(mainDashboardData)
        }
    }, [mainDashboardData])

    console.log(user, 'checkUser')

    return (
        <Layout>
            <div>
                {greetingBasedOnTime(
                    `${user?.emp_firstname + ' ' + user?.emp_lastname}`,
                    'Welcome to your Dashboard'
                )}
            </div>
            <div className="dashboard">
                <h4 className="dcTitle">Products</h4>
                <div className="dashboardCard">
                    {cardList.map((data, index) => (
                        <div
                            key={index}
                            className="infoCard"
                            // style={{
                            //     filter: `hue-rotate(${hue + index * 40}deg)`,
                            // }}
                        >
                            <Button
                                id="dashboard_count"
                                onClick={() => handleRedirect(data.path)}
                            >
                                <h3>{data.count}</h3>
                                <h6>{data.label}</h6>
                            </Button>
                        </div>
                    ))}
                </div>
                <div>
                    <h4 className="dcTitle">Transactions Per Month</h4>
                    <div className="dashboardCard">
                        {reportList.map((data, index) => (
                            <div key={index} className="infoCard">
                                <Button id="dashboard_count">
                                    <h3>
                                        {`${data.symbol ? data.symbol : ''}`}{' '}
                                        {data.count}
                                    </h3>
                                    <h6>{data.label}</h6>
                                </Button>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default Dashboard
